define('presentation/signup/facades/signupSecurityFacade',[
        'businessServices/signup/signupSessionStore',
        'externalDependencies/clientApi',
        'presentation/signup/presentationObjects/signupSecurityPresentationObject',
    ],
    function() {
        let _promiseFactory = null;
        let _clientApi = null;
        let _signupSessionStore = null;

        const SignupSecurityPresentationObjectConstructor = require('presentation/signup/presentationObjects/signupSecurityPresentationObject');

        const _savePassword = (password) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.savePassword(password)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _saveVerificationAnswer = (verificationAnswer) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.saveVerificationAnswer(verificationAnswer)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _saveVerificationQuestion = (verificationQuestionId) => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.saveVerificationQuestion(verificationQuestionId)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _setSecurityCompleted = (isSecurityCompleted) => {
            return _promiseFactory.deferIndefinitely((promise) => {
                _signupSessionStore.setSecurityCompleted(isSecurityCompleted)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _loadSignupSession = () => {
            return _promiseFactory.defer((promise) => {
                _signupSessionStore.getState()
                    .fail(promise.reject)
                    .done((signupSession) => {
                        let signupSecurityPresentationObject = new SignupSecurityPresentationObjectConstructor();
                        signupSecurityPresentationObject.password = signupSession.password;
                        signupSecurityPresentationObject.verificationQuestionId = signupSession.signupDocument.verificationQuestionId;
                        signupSecurityPresentationObject.verificationAnswer = signupSession.signupDocument.verificationAnswer;
                        promise.resolve(signupSecurityPresentationObject);
                    });
            });
        };

        const _init = (promiseFactory) => {
            _promiseFactory = promiseFactory;

            const ClientApiConstructor = require('externalDependencies/clientApi');
            _clientApi = new ClientApiConstructor();
            _clientApi.init();

            const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');
            _signupSessionStore = new SignupSessionStoreConstructor();
            _signupSessionStore.init();
        };


        return function() {
            let self = this;
            self.init = _init;

            self.savePassword = _savePassword;
            self.saveVerificationAnswer = _saveVerificationAnswer;
            self.saveVerificationQuestion = _saveVerificationQuestion;
            self.setSecurityCompleted = _setSecurityCompleted;
            self.loadSignupSession = _loadSignupSession;
        };
    });

